import { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom';
import { DynamicPages } from '../lib/dynamic-pages'
import { LoadingFallback } from './ui/loading-fallback'
import { ProtectedRoute } from './protected-route'

export function AppRoutes() {
  return (
		<Suspense fallback={<LoadingFallback className='h-96' />}>
			<Routes>
				<Route
					path='/'
					element={<DynamicPages.Home />}
				/>
				<Route
					path='/como-se-faz'
					element={<DynamicPages.ComoSeFaz />}
				/>
				<Route
					path='/auth/*'
					element={<DynamicPages.Auth />}
				/>
				<Route 
          path="/painel" 
          element={
            <ProtectedRoute>
              <DynamicPages.Dashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/relatorios" 
          element={
            <ProtectedRoute>
              <DynamicPages.Reports />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/relatorios/criar" 
          element={
            <ProtectedRoute>
              <DynamicPages.CreateReport />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/relatorios/editar/:id" 
          element={
            <ProtectedRoute>
              <DynamicPages.EditReport />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/projetos" 
          element={
            <ProtectedRoute>
              <DynamicPages.Projects />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/projetos/criar" 
          element={
            <ProtectedRoute>
              <DynamicPages.CreateProject />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/projetos/editar/:id" 
          element={
            <ProtectedRoute>
              <DynamicPages.EditProject />
            </ProtectedRoute>
          } 
        />
        {/* Posts Management Routes */}
        <Route
          path="/projetos/:projectId/posts"
          element={
            <ProtectedRoute>
              <DynamicPages.PostsManage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projetos/:projectId/posts/criar"
          element={
            <ProtectedRoute>
              <DynamicPages.PostsCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projetos/:projectId/posts/editar/:postId"
          element={
            <ProtectedRoute>
              <DynamicPages.PostsEdit />
            </ProtectedRoute>
          }
        />
        {/* Events Management Routes (Portuguese) */}
        <Route
          path="/projetos/:projectId/eventos"
          element={
            <ProtectedRoute>
              <DynamicPages.EventsManage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projetos/:projectId/eventos/criar"
          element={
            <ProtectedRoute>
              <DynamicPages.EventsCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projetos/:projectId/eventos/editar/:eventId"
          element={
            <ProtectedRoute>
              <DynamicPages.EventsEdit />
            </ProtectedRoute>
          }
        />
        {/* Events Management Routes (English aliases) */}
        <Route
          path="/projetos/:projectId/events"
          element={
            <ProtectedRoute>
              <DynamicPages.EventsManage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projetos/:projectId/events/criar"
          element={
            <ProtectedRoute>
              <DynamicPages.EventsCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projetos/:projectId/events/editar/:eventId"
          element={
            <ProtectedRoute>
              <DynamicPages.EventsEdit />
            </ProtectedRoute>
          }
        />
        {/* Products Management Routes (Portuguese) */}
        <Route
          path="/projetos/:projectId/produtos"
          element={
            <ProtectedRoute>
              <DynamicPages.ProductsManage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projetos/:projectId/produtos/criar"
          element={
            <ProtectedRoute>
              <DynamicPages.ProductsCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projetos/:projectId/produtos/editar/:productId"
          element={
            <ProtectedRoute>
              <DynamicPages.ProductsEdit />
            </ProtectedRoute>
          }
        />
        {/* Products Management Routes (English aliases) */}
        <Route
          path="/projetos/:projectId/products"
          element={
            <ProtectedRoute>
              <DynamicPages.ProductsManage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projetos/:projectId/products/criar"
          element={
            <ProtectedRoute>
              <DynamicPages.ProductsCreate />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projetos/:projectId/products/editar/:productId"
          element={
            <ProtectedRoute>
              <DynamicPages.ProductsEdit />
            </ProtectedRoute>
          }
        />
        
        {/* Reports Management Routes */}
        <Route
          path="/projetos/:projectId/relatorios"
          element={
            <ProtectedRoute>
              <DynamicPages.ReportsManage />
            </ProtectedRoute>
          }
        />
        
        
        {/* Deprecated routes - redirect to Portuguese equivalents */}
        <Route 
          path="/reports" 
          element={
            <ProtectedRoute>
              <DynamicPages.Reports />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/carteira" 
          element={
            <ProtectedRoute>
              <DynamicPages.Wallet />
            </ProtectedRoute>
          } 
        />
        <Route
          path="/conta"
          element={
            <ProtectedRoute>
              <DynamicPages.Conta />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tokens"
          element={
            <ProtectedRoute>
              <DynamicPages.Tokens />
            </ProtectedRoute>
          }
        />
        <Route
          path="/certs"
          element={
            <ProtectedRoute>
              <DynamicPages.Certs />
            </ProtectedRoute>
          }
        />
			</Routes>
		</Suspense>
	);
}